<template>
<div class="chapter">
<div class="inner_page">
<p class="line">____________________</p>
<p class="inset"><i>Now consider the man. He does not overhunt. He does not overeat. Man is one with great nature. The oaf can learn much from the man. His sun rises in gold but sets in blood. His fire burns the world.</i></p>
<p class="center">—Great Scripture</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// script.vue?30f169c6